import React from 'react';

export default function PortalHome() {
  return (
    <>
      <h1 className="wp-portal__page-title">Dashboard</h1>
      <p className="wp-portal__page-sub">Overview of your publishing account.</p>

      <div className="wp-portal__stats">
        {[
          { label: 'Total Royalties',    value: '$0.00',         note: 'No data yet' },
          { label: 'Songs',              value: '0',             note: 'None registered' },
          { label: 'Pending Statements', value: '0',             note: 'No statements available' },
        ].map(({ label, value, note }) => (
          <div key={label} className="wp-portal__stat">
            <p className="wp-portal__stat-label">{label}</p>
            <p className="wp-portal__stat-value">{value}</p>
            <p className="wp-portal__stat-note">{note}</p>
          </div>
        ))}
      </div>

      <div className="wp-portal__empty">
        <p className="wp-portal__empty-label">
          No activity to display. Your account data will appear here once your
          catalog and statements are active.
        </p>
      </div>
    </>
  );
}
